import * as Effects from 'redux-saga/effects'
import {
  IRequestCreateReservation,
  toggleCreateReservationModal,
  toggleUpdateReservationModal,
} from '../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import invoiceRejected from '../../../actions/invoices/invoiceRejected'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'
import {
  getUserScope,
  getWorkerId,
} from '../../../reducers/userAccount/selectors/userAccount'
import { PermissionScope } from '../../../containers/Employees'
import { fireToastError } from '../../../actions/toasts/fireToast'
import i18n from '../../../i18n'
import { Mixpanel } from '../../../utils/Mixpanel'

function* requestCreate(action: IRequestCreateReservation) {
  const userScopes = yield Effects.select(getUserScope)
  const workerId = yield Effects.select(getWorkerId)

  const allowReservationView = (userScopes || []).some(
    s => s === PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS,
  )
  const allowReservationEdit = (userScopes || []).some(
    s => s === PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS,
  )

  if (!allowReservationView || (!allowReservationEdit && !action.eventId)) {
    Mixpanel.track('Employee Access Denied', {
      'Employee ID': workerId,
    })
    return yield Effects.put(fireToastError(i18n.t('BED_3621_no_permission')))
  }

  yield Effects.put(invoiceRejected(true))

  if (!action.roomId) {
    yield Effects.put(
      toggleCreateReservationModal(true, action.roomId, action.from),
    )
  } else {
    const { eventId } = action

    if (eventId) {
      yield Effects.put(toggleUpdateReservationModal(eventId))
    } else {
      yield Effects.put(
        toggleCreateReservationModal(true, action.roomId, action.from),
      )
    }
  }
}

function* toggleWithLoad(action) {
  const userScopes = yield Effects.select(getUserScope)
  const workerId = yield Effects.select(getWorkerId)

  const allowReservationEdit = (userScopes || []).some(
    s => s === PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS,
  )

  if (!allowReservationEdit) {
    Mixpanel.track('Employee Access Denied', {
      'Employee ID': workerId,
    })
    return yield Effects.put(fireToastError(i18n.t('BED_3621_no_permission')))
  }

  yield Effects.put(toggleUpdateReservationModal(action.id, action.toggle))
}

export function* clearInvoice() {
  yield Effects.put(invoiceRejected(true))
}

function* requestUpdateModal(action: any) {
  const userScopes = yield Effects.select(getUserScope)
  const workerId = yield Effects.select(getWorkerId)

  const allowReservationEdit = (userScopes || []).some(
    s => s === PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS,
  )

  if (!allowReservationEdit) {
    Mixpanel.track('Employee Access Denied', {
      'Employee ID': workerId,
    })
    return yield Effects.put(fireToastError(i18n.t('BED_3621_no_permission')))
  }

  yield Effects.put({
    ...action,
    type: ReservationModalActions.ToggleUpdateReservationModalRedux,
  })
}

function* requestCreateModal(action: any) {
  const userScopes = yield Effects.select(getUserScope)
  const workerId = yield Effects.select(getWorkerId)

  const allowReservationEdit = (userScopes || []).some(
    s => s === PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS,
  )

  if (!allowReservationEdit) {
    Mixpanel.track('Employee Access Denied', {
      'Employee ID': workerId,
    })
    return yield Effects.put(fireToastError(i18n.t('BED_3621_no_permission')))
  }

  yield Effects.put({
    ...action,
    type: ReservationModalActions.ToggleCreateReservationModalRedux,
  })
}

export default function*() {
  yield Effects.takeEvery(
    ReservationModalActions.ToggleCreateReservationModal,
    requestCreateModal,
  )

  yield Effects.takeEvery(
    ReservationModalActions.ToggleUpdateReservationModal,
    requestUpdateModal,
  )

  yield Effects.takeEvery(
    ReservationModalActions.RequestCreateReservation,
    requestCreate,
  )
  yield Effects.takeEvery(
    ReservationModalActions.ToggleCreateReservationModalRedux,
    clearInvoice,
  )
  yield Effects.takeLatest(
    ReservationModalActions.ToggleUpdateReservationModalWithLoad,
    toggleWithLoad,
  )

  // while (true) {
  //   yield Effects.all([
  //     // Effects.take(ProvenancesActions.ProvenancesAreAccepted),
  //     // Effects.take(PaymentDictionaryActions.PaymentDictionaryAccepted),
  //     //Effects.take(ReservationModalActions.SetFieldsVisibility),
  //   ])
  //   yield Effects.put(toggleReservationModalLoading(false))
  // }
}
